import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { fontFamily, size, space } from '../../constants.js';
import { truncateStyles } from '../../styles/utils.js';
import { fontVariation } from '../../styles/fontStyles.js';
import { palette } from '../../palette/index.js';

const propKeys = {
    position: true,
    display: true,
    flex: true,
    color: true,
    bg: true,
    w: true,
    h: true,
    m: true,
    ml: true,
    mr: true,
    mb: true,
    mt: true,
    mx: true,
    my: true,
    p: true,
    pl: true,
    pr: true,
    pb: true,
    pt: true,
    px: true,
    py: true,
    fontSize: true,
    fontFamily: true,
    fontWeight: true,
    monospace: true,
    disambiguate: true,
    tabularFigures: true,
    letterSpacing: true,
    lineHeight: true,
    textTransform: true,
    truncate: true,
    borderRadius: true
};
const Box = styled("div", {
    shouldForwardProp: (prop)=>isPropValid(prop) && !propKeys[prop]
})((props)=>{
    var _palette_props_color, _space_props_borderRadius;
    return {
        "&:not(.disableBoxProps)": {
            position: props.position,
            display: props.display,
            flex: props.flex,
            color: props.color ? (_palette_props_color = palette[props.color]) !== null && _palette_props_color !== void 0 ? _palette_props_color : props.color : undefined,
            backgroundColor: props.bg ? palette[props.bg] : undefined,
            borderRadius: props.borderRadius ? (_space_props_borderRadius = space[props.borderRadius]) !== null && _space_props_borderRadius !== void 0 ? _space_props_borderRadius : props.borderRadius : undefined,
            width: props.w ? space[props.w] : undefined,
            height: props.h ? space[props.h] : undefined,
            margin: props.m ? space[props.m] : undefined,
            marginLeft: props.ml ? space[props.ml] : props.mx ? space[props.mx] : undefined,
            marginRight: props.mr ? space[props.mr] : props.mx ? space[props.mx] : undefined,
            marginTop: props.mt ? space[props.mt] : props.my ? space[props.my] : undefined,
            marginBottom: props.mb ? space[props.mb] : props.my ? space[props.my] : undefined,
            padding: props.p ? space[props.p] : undefined,
            paddingLeft: props.pl ? space[props.pl] : props.px ? space[props.px] : undefined,
            paddingRight: props.pr ? space[props.pr] : props.px ? space[props.px] : undefined,
            paddingTop: props.pt ? space[props.pt] : props.py ? space[props.py] : undefined,
            paddingBottom: props.pb ? space[props.pb] : props.py ? space[props.py] : undefined,
            fontSize: props.fontSize ? size[props.fontSize] : undefined,
            fontFamily: props.fontFamily ? fontFamily[props.fontFamily] : undefined,
            letterSpacing: props.letterSpacing,
            lineHeight: props.lineHeight,
            textTransform: props.textTransform,
            ...(props.fontWeight || props.monospace || props.tabularFigures || props.slashedZero || props.disambiguate) && fontVariation({
                isMonospace: !!props.monospace,
                weight: props.fontWeight,
                tabularFigures: !!props.tabularFigures,
                slashedZero: !!props.slashedZero,
                disambiguate: !!props.disambiguate
            }),
            ...props.truncate && truncateStyles
        }
    };
});

export { Box };
